// Duplicate of BracketCard for the landing page without creating a barrel file
import { BracketCard } from "../madness/BracketCard"

export const LandingBracketCard = BracketCard
